import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { faTrash, faPaperPlane, faUnlockAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UserScope, BuildingUserType } from '../../../../../../store/buildinguser/types';
import './BuildingUserRow.css';

const userTypeOptions = [
  {
    label: 'Board Member',
    value: 'board_member',
  },
  {
    label: 'Property Manager',
    value: 'property_manager',
  },
  {
    label: 'Engineer',
    value: 'engineer',
  },
  {
    label: 'Mechanical Provider',
    value: 'mechanical',
  },
  {
    label: 'Installer',
    value: 'installer',
  },
];

export interface Props {
  user: BuildingUserType;
  userScopesOptions: UserScope[];
  onAction(type: string, apiLocation: string, email: string): void;
  onRemovePermission(permission: UserScope, email: string): void;
  onAddPermission(permission: OptionType, apiLocation: string, email: string): void;
}

interface State {
  permissionScopes: OptionType[];
  permissionScopeOptions: OptionType[];
}

interface OptionType {
  label: string;
  value: string;
  disabled?: boolean;
}

export class BuildingUserRow extends Component<Props, State> {
  state = {
    permissionScopes: [],
    permissionScopeOptions: [],
  };

  componentDidMount() {
    const {
      user: { permission_scopes: permissionScopes },
      userScopesOptions,
    } = this.props;
    const tempUserScopes: OptionType[] = [];
    const tempUserScopeOptions: OptionType[] = [];

    permissionScopes.map((permission) => {
      tempUserScopes.push({
        label: permission.name,
        value: permission.identifier,
        disabled: permission.is_read_only,
      });
    });

    userScopesOptions.map((permission) => {
      tempUserScopeOptions.push({
        label: permission.name,
        value: permission.identifier,
        disabled: permission.is_read_only,
      });
    });

    this.setState((state) => ({
      ...state,
      permissionScopes: tempUserScopes,
      permissionScopeOptions: tempUserScopeOptions,
    }));
  }

  getUserRole = (userRole: string) => {
    return (userTypeOptions.find((roleOption) => roleOption.value === userRole) || userTypeOptions[0]).label;
  };

  onPermissionChange = (option: OptionType[]) => {
    const {
      user: { add_permission_api_location, permission_scopes, email },
      onRemovePermission,
      onAddPermission,
    } = this.props;
    const { permissionScopes } = this.state;

    const difference: OptionType[] = permissionScopes.filter((x) => !option.includes(x));

    option.map((x) => {
      const tempPermissionList = permissionScopes.filter((permission: OptionType) => permission.value === x.value);

      // if option from options list is not in the permissionScopes variable
      if (tempPermissionList.length === 0) {
        onAddPermission(x, add_permission_api_location, email);
      }
    });

    if (difference.length) {
      const removedPermission = permission_scopes.filter(
        (permission: UserScope) => permission.identifier === difference[0].value,
      );

      if (removedPermission) {
        onRemovePermission(removedPermission[0], email);
      }
    }
  };

  resendInvite = () => {
    const {
      user: { resend_invite_api_location: resendInviteApiLocation, email },
      onAction,
    } = this.props;

    onAction('resendInvite', resendInviteApiLocation, email);
  };

  resetPassword = () => {
    const {
      user: { reset_password_api_location: resetPasswordApiLocation, email },
      onAction,
    } = this.props;

    onAction('resetPassword', resetPasswordApiLocation, email);
  };

  revokeAccess = () => {
    const {
      user: { revoke_access_api_location: revokeAccessApiLocation, email },
      onAction,
    } = this.props;

    onAction('revokeAccess', revokeAccessApiLocation, email);
  };

  render() {
    const columnClass = 'building-user-row__element';
    const columnClassWide = 'building-user-row__element wide';
    const columnClassDesktop = columnClass + 'building-user-row--desktop-only';
    const {
      user: { email, building, user_role, status, show_resend: showResend, show_reset_password: showResetPassword },
    } = this.props;
    const { permissionScopes, permissionScopeOptions } = this.state;

    const customStyles = {
      control: (styles: any) => ({
        ...styles,
        height: 'auto',
        border: '1px solid #abadae',
        margin: '1.2rem 0',
        boxShadow: '0 1px 0 0 rgba(46, 50, 53, 0.1)',
        fontWeight: '400',
        textAlign: 'left',
      }),
      option: (provided: any) => ({
        ...provided,
        fontWeight: '400',
        textAlign: 'left',
      }),
    };

    const userRole = this.getUserRole(user_role);

    return (
      <div className="building-user-row">
        <div className={columnClassWide}>{email}</div>
        <div className="building-user-row__column">
          <Select
            id="user-permissions"
            styles={customStyles}
            options={permissionScopeOptions}
            className="account__dropdown"
            onChange={(selectedOption: any) => {
              this.onPermissionChange(selectedOption);
            }}
            value={permissionScopes}
            isOptionDisabled={(option: OptionType) => option.disabled === true}
            isMulti={true}
            isDisabled={status === 'Pending'}
          />
        </div>
        <div className={columnClassWide}>{building}</div>
        <div className={columnClass}>{userRole}</div>
        <div className={columnClass}>{status}</div>
        <div className={columnClass}>
          {showResend && (
            <div className="building-user-row__icon">
              <span className="building-user-row__button" onClick={this.resendInvite}>
                <FontAwesomeIcon icon={faPaperPlane} size="lg" color="#0295a6" />
              </span>
            </div>
          )}
          {showResetPassword && (
            <div className="building-user-row__icon">
              <span className="building-user-row__button" onClick={this.resetPassword}>
                <FontAwesomeIcon icon={faUnlockAlt} size="lg" color="#0295a6" />
              </span>
            </div>
          )}
          <div className="building-user-row__icon">
            <span className="building-user-row__button" onClick={this.revokeAccess}>
              <FontAwesomeIcon icon={faTrash} size="lg" color="#0295a6" />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    userScopesOptions: state.buildingUserReducer.userScopes,
  };
}

export const ConnectedBuildingUserRow = connect(mapStateToProps)(BuildingUserRow);
